<template>
  <div class="container-fluid m-4">
    <div class="row no-gutters">
      <div class="col">
        <form-container
          :orientation="'horizontal'"
          v-bind:model-state="modelState"
          v-bind:error-message="formError"
        >
          <div class="row">
            <div class="col-11">
              <div class="detail-item">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col">
                      <h2>{{ $t('license_title') }}</h2>
                      <p>
                        {{ $t('license_sub_title') }}
                      </p>
                      <text-input
                        v-bind="formItems.licenseName"
                        v-model="formItems.licenseName.value"
                      />
                      <div class="row">
                        <div class="col-4 col-form-label">
                          {{ $t('license_product') }}
                        </div>
                        <div class="col-2">
                          <text-input
                            v-bind="formItems.pc1"
                            v-model="formItems.pc1.value"
                          />
                        </div>

                        <div class="col-2">
                          <text-input
                            v-bind="formItems.pc2"
                            v-model="formItems.pc2.value"
                          />
                        </div>

                        <div class="col-2">
                          <text-input
                            v-bind="formItems.pc3"
                            v-model="formItems.pc3.value"
                          />
                        </div>

                        <div class="col-2">
                          <text-input
                            v-bind="formItems.pc4"
                            v-model="formItems.pc4.value"
                          />
                        </div>
                      </div>
                      <text-input
                        v-bind="formItems.activationCode"
                        v-model="formItems.activationCode.value"
                      />
                    </div>
                  </div>

                  <div class="row p-3">
                    <div class="col">
                      <loading-button
                        v-if="isEditing === false"
                        @click="isEditing = true"
                        class="btn-secondary mr-3"
                        :title="$t('edit')"
                        :is-busy="false"
                      />

                      <loading-button
                        v-if="isEditing === true"
                        @click="save"
                        class="btn-primary mr-3"
                        :title="$t('save')"
                        :is-busy="isBusy"
                      />

                      <loading-button
                        class="btn-secondary mr-3"
                        :title="$t('copy')"
                        :is-busy="false"
                        @click="copyLicence"
                        :enabled="validLength"
                      />
                    </div>

                    <div class="col-12">
                      <hr />
                      <div class="row mt-4">
                        <div class="col-10">
                          <textarea-input
                            class="mb-0"
                            :placeholder="$t('license_product')"
                            v-bind="formItems.paste"
                            v-model="formItems.paste.value"
                          >
                          </textarea-input>
                        </div>
                        <div class="col-2 d-flex align-items-center">
                              <loading-button

                        @click="openFromTextArea"
                        class="btn-primary mr-3"
                        :title="$t('license_open')"
                        :is-busy="false"
                      />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form-container>
      </div>
    </div>
  </div>
</template>
<script>
import {
  FormControl,
  FormConfig,
  FormTextConfig,
  FormTextAreaConfig
} from 'libs/classes/form.js';

import { i18n } from '@/localize.js';

const form = new FormControl();
const config = form.config;
// i18n.t('orderline.articlekind')
form.add(new FormTextConfig('licenseName', i18n.t('license_name'), null, true));
form.add(new FormTextConfig('pc1', null, null, true));
form.add(new FormTextConfig('pc2', null, null, true));
form.add(new FormTextConfig('pc3', null, null, true));
form.add(new FormTextConfig('pc4', null, null, true));

form.config['pc1'].maxlength = 10;
form.config['pc2'].maxlength = 6;
form.config['pc3'].maxlength = 10;
form.config['pc4'].maxlength = 7;

form.add(new FormTextAreaConfig('paste', i18n.t('license_paste'), null));

form.add(
  new FormTextConfig('activationCode', i18n.t('license_ac'), null, true)
);

import formmixin from '@/forms/components.js';

import LicenseController from '@/controller/licensecontroller.js';
const controller = new LicenseController();

export default {
  mixins: [formmixin],
  data() {
    return {
      formItems: config,
      formControl: form,

      modelState: [],
      formError: null,
      prc: '',
      isEditing: false,
      showPasteField: false,
      isBusy: false
    };
  },
  async mounted() {
    let result = await controller.Get();

    let decompose = this.decomposeProductCode(result.productCode);

    Object.assign(result, decompose);
    form.loadData(result);

    this.EnableOrDisableFields(false);

    this.prc = result;
  },
  methods: {
    async save() {
      this.formError = null;

      let productCode = this.getComposedProductCode();

      let data = form.getFormData();

      Object.assign(data, { productCode });

      try {
        this.isBusy = true;

        let result = await controller.Save(data);
        this.isEditing = false;
        this.$toaster.showInfo(this.$t('batch_action_succeeded'));
      } catch (error) {
        if (error.Error) {
          this.formError = error.Error;
        }
      } finally {
        this.isBusy = false;
      }
    },
    decomposeProductCode(productCode) {
      if (productCode != null) {
        var length = productCode.length;

        let prc = {
          pc1: productCode.substring(0, 10),
          pc2:
            length === 32
              ? productCode.substring(10, 15)
              : productCode.substring(10, 16),
          pc3:
            length === 32
              ? productCode.substring(15, 25)
              : productCode.substring(16, 26),
          pc4:
            length === 32
              ? productCode.substring(25, 32)
              : productCode.substring(26, 33)
        };
        return prc;
      }
    },
    EnableOrDisableFields(areEnabled) {
      this.formItems.licenseName.enabled = areEnabled;
      this.formItems.activationCode.enabled = areEnabled;

      this.formItems.pc1.enabled = areEnabled;
      this.formItems.pc2.enabled = areEnabled;
      this.formItems.pc3.enabled = areEnabled;
      this.formItems.pc4.enabled = areEnabled;
    },
    copyLicence() {
      let licenseName = this.formItems.licenseName.value;
      let activationCode = this.formItems.activationCode.value;

      let productCode = this.getComposedProductCode();
      let result = `${licenseName}\n${productCode}\n${activationCode}`;

      copy(result);
      this.$toaster.showInfo(this.$t('license_copied'));
    },
    getComposedProductCode() {
      let pc1 = this.formItems.pc1.value;
      let pc2 = this.formItems.pc2.value;
      let pc3 = this.formItems.pc3.value;
      let pc4 = this.formItems.pc4.value;

      let productCode = [pc1, pc2, pc3, pc4].join('-');
      return productCode;
    },
    pasteProductCode() {
      this.isEditing = true;

      this.showPasteField = true;
    },
    openFromTextArea() {
      if (this.formItems.paste.value) {
        let paste = this.formItems.paste.value;

        var str = paste.split('\n');
        if (str.length === 3 || str.length === 4) {
          for (let index = 0; index < str.length; index++) {
            let element = str[index];

            let copyElement = new String(element);

            if (copyElement) {
              try {
                if (copyElement.includes(':')) {
                  let strIndex = copyElement.indexOf(':');
                  strIndex = strIndex += 1;

                  copyElement = copyElement.substring(strIndex);
                  copyElement = copyElement.trim();

                  this.isEditing = true;
                  this.EnableOrDisableFields(true);

                  if (index === 0) {
                    this.formItems.licenseName.value = copyElement;
                  }
                  if (index === 1) {
                    copyElement = copyElement.replace(/-/g, '');

                    let decomposed = this.decomposeProductCode(copyElement);
                    this.formItems.pc1.value = decomposed.pc1;
                    this.formItems.pc2.value = decomposed.pc2;
                    this.formItems.pc3.value = decomposed.pc3;
                    this.formItems.pc4.value = decomposed.pc4;
                  }
                  if (index === 2) {
                    this.formItems.activationCode.value = copyElement;
                  }
                }
              } catch (error) {
                this.$toaster.showError(this.$t('license_cannot_read'));
              }
            }
          }
        }

        if (str.length === 1) {
          try {
            if (str[0].replace(/[^-]/g, '').length === 3) {
              let productcode = str[0].replace(/-/g, '');
              var decomposed = this.decomposeProductCode(productcode);

              this.isEditing = true;
              this.EnableOrDisableFields(true);

              this.formItems.pc1.value = decomposed.pc1;
              this.formItems.pc2.value = decomposed.pc2;
              this.formItems.pc3.value = decomposed.pc3;
              this.formItems.pc4.value = decomposed.pc4;
            } else {
              this.$toaster.showError(this.$t('license_cannot_read'));
            }
          } catch (error) {
            this.$toaster.showError(this.$t('license_cannot_read'));
          }
        }
      }
    }
  },
  computed: {
    validLength() {
      if (this.formItems.pc1.value) {
        let pc1 = this.formItems.pc1.value;
        let pc2 = this.formItems.pc2.value;
        let pc3 = this.formItems.pc3.value;
        let pc4 = this.formItems.pc4.value;

        var length = pc1.length + pc2.length + pc3.length + pc4.length;
        if (length > 31) {
          return true;
        }

        return false;
      }
      return false;
    }
  },
  watch: {
    isEditing(newVal) {
      if (newVal) {
        this.EnableOrDisableFields(true);
      } else {
        this.EnableOrDisableFields(false);
      }
    }
  }
};
function copy(text) {
  var input = document.createElement('textarea');
  input.innerHTML = text;
  document.body.appendChild(input);
  input.select();
  var result = document.execCommand('copy');
  document.body.removeChild(input);
  return result;
}
</script>

<style scoped>
.detail-item {
  background-color: #ffffff;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.open-license {
  align-content: center;
  height: 50%;
  cursor: pointer;
}
</style>
